module.exports = "<app-page-contents [pageName]=\"pageName\"></app-page-contents>\n\n<p>\n    <a [routerLink]=\"['/search/images']\" class=\"btn btn-default\" role=\"button\">\n        Search images <i class=\"fa fa-angle-right\"></i>\n    </a>\n</p>\n\n<p>\n    <a [routerLink]=\"['/search/edition']\" class=\"btn btn-default\" role=\"button\">\n        Edition texts <i class=\"fa fa-angle-right\"></i>\n    </a>\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-search-info/page-search-info.component.html
// module id = ./src/app/components/pages/page-search-info/page-search-info.component.html
// module chunks = main